/**
 * Minimum sender history size required before behavioral rates are trusted.
 *
 * Support check uses `total_emails_received >= SENDER_STATS_MIN_TOTAL`
 * (equivalent to `total_emails_received > 3`).
 */
export const SENDER_STATS_MIN_TOTAL = 4

